const subscriptionNames = {
    LIFETIME: 'LIFETIME PRO COMBINATION',
    YEARLY: 'YEARLY TRADING SIGNALS COMBINATION',
    QUARTERLY: 'QUARTERLY TRADING SIGNALS COMBINATION',
    MONTHLY: 'MONTHLY TRADING SIGNALS COMBINATION'
}

export {
    subscriptionNames
}